import { useIsMedicalDoctor } from '@web-app/hooks/useIsMedicalDoctor';
import { useSyncIsMedicalDoctorAttribute } from '@web-app/utils/feature-flags/prescriber-flow';

/**
 * Renders nothing. Mounted once at the app root inside the auth/query
 * providers so that provider-wide config (e.g. medical-doctor flag) is
 * fetched on first page load and cached in React Query for the rest of
 * the session.
 *
 * Also syncs provider-wide attributes onto the GrowthBook instance so
 * flags like `is-prescriber-flow` can target the current user.
 *
 * Stack additional `use*` calls here as more provider-wide config is
 * introduced.
 */
export const PrefetchProviderConfig = (): null => {
  const { isMedicalDoctor, isLoading } = useIsMedicalDoctor();
  useSyncIsMedicalDoctorAttribute(isLoading ? undefined : isMedicalDoctor);
  return null;
};
